export const SET_WATCH_KEY = 'SET_WATCH_KEY';

export const setWatchKey = (watchKey) => ({
	type: 'SET_WATCH_KEY',
	watchKey,
});
